import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const RegionSelector = ({ currentRegion, onRegionChange, language }) => {
  const [isOpen, setIsOpen] = useState(false);

  const regions = {
    en: [
      { code: 'us', name: 'United States', flag: '🇺🇸', cities: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Miami'] },
      { code: 'uk', name: 'United Kingdom', flag: '🇬🇧', cities: ['London', 'Manchester', 'Birmingham', 'Edinburgh', 'Liverpool'] },
      { code: 'ca', name: 'Canada', flag: '🇨🇦', cities: ['Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Ottawa'] },
      { code: 'au', name: 'Australia', flag: '🇦🇺', cities: ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide'] }
    ],
    es: [
      { code: 'es', name: 'España', flag: '🇪🇸', cities: ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Bilbao'] },
      { code: 'mx', name: 'México', flag: '🇲🇽', cities: ['Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Cancún'] },
      { code: 'ar', name: 'Argentina', flag: '🇦🇷', cities: ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata'] },
      { code: 'co', name: 'Colombia', flag: '🇨🇴', cities: ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena'] }
    ],
    pt: [
      { code: 'br', name: 'Brasil', flag: '🇧🇷', cities: ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza'] },
      { code: 'pt', name: 'Portugal', flag: '🇵🇹', cities: ['Lisboa', 'Porto', 'Braga', 'Coimbra', 'Faro'] }
    ],
    fr: [
      { code: 'fr', name: 'France', flag: '🇫🇷', cities: ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice'] },
      { code: 'be', name: 'Belgique', flag: '🇧🇪', cities: ['Bruxelles', 'Anvers', 'Gand', 'Charleroi', 'Liège'] },
      { code: 'ch', name: 'Suisse', flag: '🇨🇭', cities: ['Genève', 'Zurich', 'Bâle', 'Lausanne', 'Berne'] }
    ],
    de: [
      { code: 'de', name: 'Deutschland', flag: '🇩🇪', cities: ['Berlin', 'München', 'Hamburg', 'Frankfurt', 'Köln'] },
      { code: 'at', name: 'Österreich', flag: '🇦🇹', cities: ['Wien', 'Graz', 'Linz', 'Salzburg', 'Innsbruck'] },
      { code: 'ch', name: 'Schweiz', flag: '🇨🇭', cities: ['Zürich', 'Genf', 'Basel', 'Bern', 'Lausanne'] }
    ]
  };

  const currentRegions = regions?.[language] || regions?.en;
  const selectedRegion = currentRegions?.find(r => r?.code === currentRegion) || currentRegions?.[0];

  const handleRegionSelect = (regionCode) => {
    onRegionChange(regionCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-card border border-border rounded-md hover:bg-muted transition-smooth active-press w-full sm:w-auto"
        aria-label="Select region"
        aria-expanded={isOpen}
      >
        <span className="text-xl">{selectedRegion?.flag}</span>
        <span className="text-sm font-medium text-foreground flex-1 text-left">
          {selectedRegion?.name}
        </span>
        <Icon 
          name={isOpen ? "ChevronUp" : "ChevronDown"} 
          size={16} 
          color="var(--color-foreground)"
        />
      </button>
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
            aria-hidden="true"
          />
          <div className="absolute left-0 right-0 sm:left-auto sm:right-0 top-full mt-2 w-full sm:w-64 bg-popover border border-border rounded-md shadow-elevation-4 z-50 max-h-80 overflow-y-auto">
            {currentRegions?.map((region) => (
              <button
                key={region?.code}
                onClick={() => handleRegionSelect(region?.code)}
                className={`
                  w-full flex items-center gap-3 px-4 py-3 text-left
                  transition-smooth hover:bg-muted
                  ${currentRegion === region?.code ? 'bg-muted' : ''}
                `}
              >
                <span className="text-xl">{region?.flag}</span>
                <span className="text-sm font-medium text-popover-foreground flex-1">
                  {region?.name}
                </span>
                {currentRegion === region?.code && (
                  <Icon name="Check" size={16} color="var(--color-primary)" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default RegionSelector;